import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import db from "../../../../api/mongodb";
import {
    Container,
    Row,
    Col,
    Image,
    Card,
    Button,
    Form,
} from "react-bootstrap";
import { defaultOptions1 } from "../../../../config/loading-config.js";
import Lottie from "react-lottie";
// import "./SafeAPProfile.scss";
import styles from "./SafeAPAccount.module.scss";
import "../../project/Evaluation.scss"
// import "./SafeAPRegistrationDetails.scss";
import { Formik } from "formik";
import * as Yup from "yup";
import BugReportPopup from "./BugReportPopup";

const SafeAPAccount = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [registrationDate, setRegistrationDate] = useState("");
    const { id } = useParams();
    const role = sessionStorage.getItem("name");
    const [displayPasswordMessage, setDisplayPasswordMessage] = useState("none");
    const [displayEmailMessage, setDisplayEmailMessage] = useState("none");
    const [showDisabledPasswordField, setShowDisabledPasswordField] =
        useState("block");
    const [showEditablePasswordFields, setShowEditablePasswordFields] =
        useState("none");
    const [showChangePasswordButton, setShowChangePasswordButton] =
        useState("block");
    const [showDisabledEmailField, setShowDisabledEmailField] = useState("block");
    const [showEditableEmailFields, setShowEditableEmailFields] =
        useState("none");
    const [showChangeEmailButton, setShowChangeEmailButton] = useState("block");
    const [safeApEmail, setSafeApEmail] = useState("");
    const [safeAp, setSafeAP] = useState({})
    const [showPopup, setShowPopup] = useState(false)

    useEffect(() => {
        const response = db
            .get(`api/safeAPs/${id}`, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`,
                },
            })
            .then((response) => {
                setSafeAP(response.data.formData)
                setSafeApEmail(response.data.formData.email);
                setIsLoading(false);
            });
    }, [displayPasswordMessage, displayEmailMessage]);

    if (isLoading) {
        return <Lottie options={defaultOptions1} height={200} width={200} />;
    }

    const handleCloseModal =()=>{
        setShowPopup(false)
    }

    return (
        <>
            <h3 className={styles.text_heading}>Account</h3>
            <Container fluid>
                <Row>
                    <Col md={6}>
                        <Formik
                            validateOnChange={false}
                            validateOnBlur={false}
                            initialValues={{
                                currentPassword: "",
                                newPassword: "",
                                confirmNewPassword: "",
                            }}
                            validationSchema={Yup.object().shape({
                                currentPassword: Yup.string()
                                    .required("Required")
                                    .matches(
                                        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
                                        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                                    )
                                    .test(
                                        "validator",
                                        "Invalid current password",
                                        async (value) => {
                                            if (!value) {
                                                return false;
                                            }

                                            const response = await db
                                                .post("/api/safeAPs/login", {
                                                    email: safeApEmail,
                                                    password: value,
                                                })
                                                .then((response) => {
                                                    if (response.status === 200) {
                                                        return true;
                                                    }
                                                })
                                                .catch((err) => {
                                                    return false;
                                                });

                                            if (response) {
                                                return true;
                                            } else {
                                                setDisplayPasswordMessage("none");
                                                return false;
                                            }
                                        }
                                    ),
                                newPassword: Yup.string()
                                    .required("Required")
                                    .matches(
                                        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
                                        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                                    ),
                                confirmNewPassword: Yup.string()
                                    .required("Required")
                                    .oneOf(
                                        [Yup.ref("newPassword"), null],
                                        "New passwords must match"
                                    ),
                            })}
                            onSubmit={async (values, { resetForm }) => {

                                // console.log(safeAp)
                                // var formData = Object.assign({}, safeAp)
                                // formData.password = values.password
                                db.put(
                                    `api/safeAPs/${id}`,
                                    {
                                        password: values.newPassword,
                                    },
                                    {
                                        headers: {
                                            Authorization: `${localStorage.getItem("token")}`,
                                        },
                                    }
                                );
                                setDisplayPasswordMessage("block");
                                setTimeout(() => {
                                    setShowDisabledPasswordField("block");
                                    setShowChangePasswordButton("block");
                                    setShowEditablePasswordFields("none");
                                    setDisplayPasswordMessage("none");
                                }, 1000);
                                resetForm();
                            }}
                        >
                            {(formik) => (
                                <Card
                                    className={`safe-ap-profile-subsection ${styles.card_size}`}
                                >
                                    <h5>Change password</h5>

                                    <Form onSubmit={formik.handleSubmit}>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="password"
                                            style={{ display: showDisabledPasswordField }}
                                        >
                                            <Form.Label
                                                className={styles.password_label}
                                                type="password"
                                            >
                                                Password
                                            </Form.Label>
                                            <Form.Control
                                                className={styles.form_control_border}
                                                type="text"
                                                placeholder="*****"
                                                aria-label="Disabled password"
                                                disabled
                                                readOnly
                                            />
                                        </Form.Group>
                                        {showChangePasswordButton === "block" && (
                                            <div>
                                                <Button
                                                    variant="outline-dark"
                                                    onClick={() => {
                                                        setShowDisabledPasswordField("none");
                                                        setShowChangePasswordButton("none");
                                                        setShowEditablePasswordFields("block");
                                                    }}
                                                >
                                                    Change password
                                                </Button>
                                            </div>
                                        )}
                                        <Form.Group
                                            className="mb-3"
                                            controlId="currentPassword"
                                            style={{ display: showEditablePasswordFields }}
                                        >
                                            <Form.Label
                                                className={styles.password_label}
                                                type="password"
                                            >
                                                Current Password *
                                            </Form.Label>
                                            <Form.Control
                                                className={styles.form_control_border}
                                                name="currentPassword"
                                                type="password"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.currentPassword}
                                                placeholder="Enter password"
                                            />
                                            {formik.touched.currentPassword &&
                                                formik.errors.currentPassword ? (
                                                <div className={styles.error}>
                                                    {formik.errors.currentPassword}
                                                </div>
                                            ) : null}
                                        </Form.Group>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="newPassword"
                                            style={{ display: showEditablePasswordFields }}
                                        >
                                            <Form.Label
                                                className={styles.password_label}
                                                type="password"
                                            >
                                                New Password *
                                            </Form.Label>
                                            <Form.Control
                                                className={styles.form_control_border}
                                                name="newPassword"
                                                type="password"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.newPassword}
                                                placeholder="Enter new password"
                                            />
                                            {formik.touched.newPassword &&
                                                formik.errors.newPassword ? (
                                                <div className={styles.error}>
                                                    {formik.errors.newPassword}
                                                </div>
                                            ) : null}
                                        </Form.Group>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="confirmNewPassword"
                                            style={{ display: showEditablePasswordFields }}
                                        >
                                            <Form.Label
                                                className={styles.password_label}
                                                type="password"
                                            >
                                                Confirm new Password *
                                            </Form.Label>
                                            <Form.Control
                                                className={styles.form_control_border}
                                                name="confirmNewPassword"
                                                type="password"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.confirmNewPassword}
                                                placeholder="Confirm new password"
                                            />
                                            {formik.touched.confirmNewPassword &&
                                                formik.errors.confirmNewPassword ? (
                                                <div className={styles.error}>
                                                    {formik.errors.confirmNewPassword}
                                                </div>
                                            ) : null}
                                        </Form.Group>
                                        <Button
                                            type="submit"
                                            style={{
                                                display:
                                                    showEditablePasswordFields === "block"
                                                        ? "inline-block"
                                                        : "none",
                                            }}
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            className={styles.cancel_button}
                                            style={{
                                                display:
                                                    showEditablePasswordFields === "block"
                                                        ? "inline-block"
                                                        : "none",
                                            }}
                                            variant="outline-danger"
                                            onClick={() => {
                                                setShowEditablePasswordFields("none");
                                                setShowDisabledPasswordField("block");
                                                setShowChangePasswordButton("block");
                                            }}
                                        >
                                            Cancel
                                        </Button>{" "}
                                    </Form>

                                    <p
                                        className={styles.onSave_message}
                                        style={{
                                            display: displayPasswordMessage,
                                        }}
                                    >
                                        <strong>Password saved!</strong>
                                    </p>
                                </Card>
                            )}
                        </Formik>
                    </Col>

                    <Col md={6}>
                        <Formik
                            validateOnChange={false}
                            validateOnBlur={false}
                            initialValues={{
                                newEmail: "",
                                confirmPassword: "",
                            }}
                            validationSchema={Yup.object().shape({
                                confirmPassword: Yup.string()
                                    .required("Required")
                                    .matches(
                                        /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
                                        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                                    )
                                    .test(
                                        "validator",
                                        "Invalid current password",
                                        async (value) => {
                                            if (!value) {
                                                return false;
                                            }

                                            const response = await db
                                                .post("/api/safeAPs/login", {
                                                    email: safeApEmail,
                                                    password: value,
                                                })
                                                .then((response) => {
                                                    if (response.status === 200) {
                                                        return true;
                                                    }
                                                })
                                                .catch((err) => {
                                                    return false;
                                                });

                                            if (response) {
                                                return true;
                                            } else {
                                                setDisplayEmailMessage("none");
                                                return false;
                                            }
                                        }
                                    ),
                                newEmail: Yup.string()
                                    .email("Must be a valid email")
                                    .max(255)
                                    .required("Email is required"),
                            })}
                            onSubmit={async (values, { resetForm }) => {

                                console.log(safeAp)
                                var formData = Object.assign({}, safeAp)
                                formData.email = values.newEmail
                                db.put(
                                    `/api/safeAPs/${id}`,
                                    {
                                        // contact: { email: values.newEmail },
                                        formData: formData
                                    },
                                    {
                                        headers: {
                                            Authorization: `${localStorage.getItem("token")}`,
                                        },
                                    }
                                );
                                setDisplayEmailMessage("block");

                                setTimeout(() => {
                                    setShowDisabledEmailField("block");
                                    setShowChangeEmailButton("block");
                                    setShowEditableEmailFields("none");
                                    setDisplayEmailMessage("none");
                                }, 1000);
                                resetForm();
                            }}
                        >
                            {(formik) => (
                                <Card
                                    className={`safe-ap-profile-subsection ${styles.card_size}`}
                                >
                                    <h5>Change email</h5>

                                    <Form onSubmit={formik.handleSubmit}>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="password"
                                            style={{ display: showDisabledEmailField }}
                                        >
                                            <Form.Label className={styles.password_label} type="text">
                                                Email
                                            </Form.Label>
                                            <Form.Control
                                                className={styles.form_control_border}
                                                type="text"
                                                placeholder={safeApEmail}
                                                aria-label="Disabled password"
                                                disabled
                                                readOnly
                                            />
                                        </Form.Group>
                                        {showChangeEmailButton === "block" && (
                                            <div>
                                                <Button
                                                    variant="outline-dark"
                                                    onClick={() => {
                                                        setShowDisabledEmailField("none");
                                                        setShowChangeEmailButton("none");
                                                        setShowEditableEmailFields("block");
                                                    }}
                                                >
                                                    Change email
                                                </Button>
                                            </div>
                                        )}
                                        <Form.Group
                                            className="mb-3"
                                            controlId="newEmail"
                                            style={{ display: showEditableEmailFields }}
                                        >
                                            <Form.Label
                                                className={styles.password_label}
                                                type="password"
                                            >
                                                New email *
                                            </Form.Label>
                                            <Form.Control
                                                className={styles.form_control_border}
                                                name="newEmail"
                                                type="text"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.newEmail}
                                                placeholder="Enter email"
                                            />

                                            {formik.touched.newEmail && formik.errors.newEmail ? (
                                                <div className={styles.error}>
                                                    {formik.errors.newEmail}
                                                </div>
                                            ) : null}
                                        </Form.Group>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="confirmPassword"
                                            style={{ display: showEditableEmailFields }}
                                        >
                                            <Form.Label
                                                className={styles.password_label}
                                                type="password"
                                            >
                                                Confirm Password *
                                            </Form.Label>
                                            <Form.Control
                                                className={styles.form_control_border}
                                                name="confirmPassword"
                                                type="password"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.confirmPassword}
                                                placeholder="Confirm your current password"
                                            />
                                            {formik.touched.confirmPassword &&
                                                formik.errors.confirmPassword ? (
                                                <div className={styles.error}>
                                                    {formik.errors.confirmPassword}
                                                </div>
                                            ) : null}
                                        </Form.Group>
                                        <Button
                                            type="submit"
                                            style={{
                                                display:
                                                    showEditableEmailFields === "block"
                                                        ? "inline-block"
                                                        : "none",
                                            }}
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            className={styles.cancel_button}
                                            style={{
                                                display:
                                                    showEditableEmailFields === "block"
                                                        ? "inline-block"
                                                        : "none",
                                            }}
                                            variant="outline-danger"
                                            onClick={() => {
                                                setShowEditableEmailFields("none");
                                                setShowDisabledEmailField("block");
                                                setShowChangeEmailButton("block");
                                            }}
                                        >
                                            Cancel
                                        </Button>{" "}
                                    </Form>

                                    <p
                                        className={styles.onSave_message}
                                        style={{
                                            display: displayEmailMessage,
                                        }}
                                    >
                                        Email saved!
                                    </p>
                                </Card>
                            )}
                        </Formik>
                    </Col>
                    <Col xxl={12} style={{ marginTop: "125px" }}>
                        <Button
                            className="survey-back-button"
                            onClick={()=>{setShowPopup(true)}}
                        >
                            Report an issue
                        </Button>
                    </Col>
                </Row>
            </Container>
            <BugReportPopup showPopup={showPopup} handleCloseModal={handleCloseModal}/>
            
        </>
    );
};

export default SafeAPAccount;
